module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link === false) ? _c(_vm.getComponent, {
    tag: "component",
    staticClass: "ui_button",
    class: _vm.getClasses,
    style: (_vm.getStyle),
    attrs: {
      "href": _vm.getHref,
      "target": _vm.target,
      "to": _vm.getHref,
      "title": _vm.title
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.iconTemplate) ? _c('div', {
    staticClass: "ui_button__pre_icon"
  }, [_c('AppSvgIcon', {
    class: _vm.iconClass,
    attrs: {
      "template": _vm.iconTemplate,
      "size": _vm.iconSize,
      "color": _vm.iconColor,
      "color-mode": _vm.iconColorMode,
      "manual-height": _vm.iconManualHeight,
      "manual-width": _vm.iconManualWidth
    }
  })], 1) : _vm._e(), (_vm.status === "loading") ? _c('spinner') : _vm._e(), (_vm.iconText) ? _c('span', {
    staticClass: "ui_button__icon_text"
  }, [_vm._v(_vm._s(_vm.iconText))]) : _vm._e(), _vm._t("default")], 2) : _c('div', {
    staticClass: "ui_link",
    class: _vm.type,
    on: {
      "click": _vm.click
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00613a0a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppButtonNew/AppButtonNew.vue
// module id = 4aa1ebaa8dd60b9682a1
// module chunks = 89